var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.center,"zoom":15,"map-type-id":"roadmap","options":{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: false,
   disableDefaultUi: false,
   styles: [
            {
              featureType: 'administrative',
              elementType: 'geometry',
              stylers: [
                        {
                          visibility: 'off'
                        }
              ]
            },
            {
               'featureType': 'poi',
               'stylers': [
                        {
                          visibility: 'off'
                        }
                ]
            },
            {
               'featureType': 'transit',
               'stylers': [
                        {
                          visibility: 'off'
                        }
                ]
            }
  ]
 }},on:{"click":_vm.clickOnMap}},[(_vm.allowLoadLocation)?_c('GmapMarker',{attrs:{"position":{lat:_vm.currentLocation.lat, lng:_vm.currentLocation.lng},"icon":_vm.currentMarkerOptions}}):_vm._e(),_vm._l((_vm.locations(true)),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":{lat:m.lat, lng:m.lng},"icon":_vm.markerOptions},on:{"click":function($event){return _vm.toggleInfoWindow(m)}}})}),_c('GmapInfoWindow',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('div',{attrs:{"id":"card"}},[_c('div',{staticClass:"card-image"}),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('h5',[_vm._v(_vm._s(_vm.displayedLocation.name))])])]),_c('div',{staticClass:"content",staticStyle:{"text-align":"left","margin-top":"5px","margin-right":"2px"}},[_c('div',{staticStyle:{"display":"inline-block","max-width":"90%"}},[_c('a',{attrs:{"href":'tel:' + _vm.displayedLocation.tel}},[_vm._v(_vm._s(_vm.displayedLocation.tel))])]),_c('div',{staticStyle:{"display":"inline-block","float":"right","margin-bottom":"10px"}},[_c('b-button',{attrs:{"variant":"outline-dark","href":_vm.displayedLocation.google_map}},[_c('img',{staticStyle:{"display":"inline-block"},attrs:{"src":require("@/assets/map.png"),"width":"30px"}})])],1),_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_vm._v(" เงื่อนไข: "),_c('p',[_vm._v(_vm._s(_vm.displayedLocation.condition))])]),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(" ค่าใช้จ่ายหากไม่เข้าเกณฑ์: "+_vm._s(_vm.displayedLocation.expend)+" ")])]),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_vm._v(" ระยะเวลาทราบผล: "+_vm._s(_vm.displayedLocation.period)+" ")])])])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }